import { Injectable } from '@angular/core';
import TooltipTypes from "../../shared/tooltip-configuration";
const TOOLTIP_POSITIONS = {
    RIGHT: 0,
    BOTTOM: 1,
    TOP: 2,
    LEFT: 3
};

const TOOLTIP_OFFSET = {
    TOP: 0,
    LEFT: 10
};
const TOOLTIP_GENERAL_OFFSET = 10;
const ASSETS_BASE_PATH = "assets/tooltip-assets/";

@Injectable({
    providedIn: 'root'
})
export class TooltipService {
    tooltipComponent: any;
    assetsPath: string = ASSETS_BASE_PATH;
    constructor() { }

    public registerTooltipComponent(component: any): void {
       this.tooltipComponent = component;
    }

    public showTooltip(targetElement: HTMLElement, options?: any): void {
        let tooltipTypeKey = targetElement.getAttribute("data-tooltip-type");
        this.tooltipComponent.setOptions(TooltipTypes[tooltipTypeKey]);
        let tooltipOptions = this.tooltipComponent.getOptions();

        if (options?.customImageName) {
            tooltipOptions.imagePath = `${ASSETS_BASE_PATH}${options.customImageName}`;
        }

        if (options?.customTextDescription) {
            tooltipOptions.textDescription = options.customTextDescription;
        }

        if (options?.imageOnly) {
            tooltipOptions.textDescription = null;
        }

        if (options?.descriptionOnly) {
            tooltipOptions.imagePath = null;
        }

        this.tooltipComponent.showTooltip(); //show to update size, then calculate + update position

        let position: string = this.computeTooltipPoisitionString(targetElement);
        this.tooltipComponent.setCustomStyle(position);
    }

    public hideTooltip(): void {
        this.tooltipComponent.hideTooltip();
    }

    private getPreferedPositioningOrder(): number[] {
        return [
            TOOLTIP_POSITIONS.RIGHT,
            TOOLTIP_POSITIONS.BOTTOM,
            TOOLTIP_POSITIONS.TOP,
            TOOLTIP_POSITIONS.LEFT
        ];
    }
 
    private computeTooltipPoisitionString(targetElement: HTMLElement): string {
        let elementRect = targetElement.getBoundingClientRect();
        let positionStyleString = this.getPositioningStyleString(elementRect);

        return positionStyleString;
    }

    private getPositioningStyleString(targetRect: ClientRect): string {
        let targetTop = Math.round(targetRect.top + window.scrollY);
        let targetRight = Math.round(targetRect.right + window.scrollX);
        let targetBottom = Math.round(targetRect.top  + window.scrollY + targetRect.height);
        let targetLeft = Math.round(targetRect.left + window.scrollX);
        let positions = this.getPreferedPositioningOrder();
        let tooltipBox = this.tooltipComponent.tooltipbox.nativeElement;
        let tooltipWidth = tooltipBox.offsetWidth;
        let tooltipHeight = tooltipBox.offsetHeight;

        while (positions.length) {
            let currentPosition = positions.shift();

            switch(currentPosition) {
                case TOOLTIP_POSITIONS.RIGHT:
                    if (this.fitsRight(targetRight, tooltipWidth)) {
                        let top = targetTop;
                        if (window.innerHeight + window.scrollY < top + tooltipHeight) {
                            top = top - (top + tooltipHeight - (window.innerHeight + window.scrollY)) - TOOLTIP_GENERAL_OFFSET;
                        }
                        return `top: ${top}px; left: ${targetRight + TOOLTIP_OFFSET.LEFT}px`;
                    }
                    break;
                case TOOLTIP_POSITIONS.BOTTOM:
                    if (this.fitsBottom(targetBottom, tooltipHeight)) {
                        let left = targetLeft;
                        if (window.innerWidth + window.scrollX < left + tooltipWidth) {
                            left = left - (left + tooltipWidth + TOOLTIP_GENERAL_OFFSET - (window.innerWidth + window.scrollX)) - TOOLTIP_GENERAL_OFFSET;
                        }
                        return `top: ${targetBottom + TOOLTIP_GENERAL_OFFSET}px; left: ${left}px`;
                    }
                    break;
                case TOOLTIP_POSITIONS.TOP:
                    if (this.fitsTop(targetTop, tooltipHeight)) {
                        let left = targetLeft;
                        if (window.innerWidth + window.scrollX < left + tooltipWidth) {
                            left = left - (left + tooltipWidth + TOOLTIP_GENERAL_OFFSET - (window.innerWidth + window.scrollX)) - TOOLTIP_GENERAL_OFFSET;
                        }
                        return `top: ${targetTop - tooltipHeight- TOOLTIP_GENERAL_OFFSET}px; left: ${left}px`;
                    }
                    break;
                case TOOLTIP_POSITIONS.LEFT:
                default:
                    let top = targetTop;
                    if (window.innerHeight + window.scrollY < top + tooltipHeight) {
                        top = top - (top + tooltipHeight - (window.innerHeight + window.scrollY)) - TOOLTIP_GENERAL_OFFSET;
                    }
                    return `top: ${top}px; left: ${targetLeft - tooltipWidth - TOOLTIP_GENERAL_OFFSET}px`;
            }
        }
    }

    private fitsRight(targetRight: number, tooltipWidth: number): boolean {
        return targetRight + 2 * TOOLTIP_GENERAL_OFFSET + tooltipWidth < window.innerWidth + window.scrollX;
    }

    private fitsBottom(targetBottom: number, tooltipHeight: number): boolean {
        return targetBottom + 2 * TOOLTIP_GENERAL_OFFSET + tooltipHeight < window.innerHeight + window.scrollY;
    }

    private fitsTop(targetTop: number, tooltipHeight: number): boolean {
        return targetTop - 2 * TOOLTIP_GENERAL_OFFSET - tooltipHeight > window.scrollY;
    }
 }
